import * as React from "react";
import { AccountFlyoutBackButton } from "./AccountFlyoutBackButton";
import CountryUtil from "../../../../../uidispatcherapi/CountryUtil";
import { MenuSectionLinks } from "./AccountFlyoutMenuSection";

type Props = {
    setPageNumber: (pageNumber: number) => void;
    display: boolean;
};

export const AccountFlyoutSubMenuPage = (props: Props) => {
    const menuSectionLinks: MenuSectionLinks | null = CountryUtil.getFlyoutConfig().menuSectionLinks || null;
    const renderSubMenuLinks = () => {
        const pagedLinks = menuSectionLinks?.business.filter((item) => item.paged);
        if (pagedLinks) {
            return pagedLinks.map((item, index) => {
                return (
                    <div key={"menuentry-link" + index} className="menuentry-link">
                        <a className="account-label menu-entry" href={item.page?.url}>
                            {item.page?.text}
                        </a>
                    </div>
                );
            });
        }
        return null;
    };
    const className = props.display ? "secondary-flyout open" : "secondary-flyout";
    return (
        <div className={className}>
            <AccountFlyoutBackButton setPageNumber={props.setPageNumber} />
            {menuSectionLinks && renderSubMenuLinks()}
        </div>
    );
};
